module.exports = __webpack_public_path__ + "static/media/bg-custom-services-desk@2x.3342af3f.png";